import * as yup from 'yup';

import { validateEmail } from 'src/utils/validators/validate-email';
import { validatePassword } from 'src/utils/validators/validate-password';

import { loginDataKeys, forgottenPasswordDataKeys } from './constants';

const errorMessages = {
    email: {
        required: 'your_details_form_email_required',
        invalid: 'your_details_form_email_invalid',
    },
    password: {
        required: 'your_details_form_password_required',
        min: 'your_details_form_password_min',
        invalid: 'your_details_form_password_invalid',
    },
};

const emailValidation = yup
    .string()
    .required(errorMessages.email.required)
    .test({ message: errorMessages.email.invalid, test: validateEmail });

const passwordValidation = yup
    .string()
    .required(errorMessages.password.required)
    .test({ message: errorMessages.password.invalid, test: validatePassword });

export const loginDataSchema = yup.object({
    [loginDataKeys.email]: emailValidation,
    [loginDataKeys.password]: passwordValidation,
});

export const loginNoPasswordValidationDataSchema = yup.object().shape({
    [loginDataKeys.email]: emailValidation,
    [loginDataKeys.password]: yup.string().required(errorMessages.password.required),
});

export const forgottenPasswordDataSchema = yup.object({
    [forgottenPasswordDataKeys.email]: emailValidation,

    [forgottenPasswordDataKeys.password]: yup.string().when('$emailSent', {
        is: true,
        then: (schema) => schema.required(errorMessages.password.required),
        otherwise: (schema) => schema.notRequired(),
    }),
});
